import "./_header.scss";

import cx from "classnames";
import {useState} from "react";
import {Link} from "react-router-dom";

import logo from "@/assets/massification/LOGO_CO-DEALS.svg";

import ButtonHamburger from "./ButtonHamburger";
import {NavLink} from "./interface";
import Nav from "./Nav";

function Header(): JSX.Element {
  const [isEtendu, setIsEtendu] = useState<boolean>(false);
  const links: NavLink[] = [
    {
      name: "Massification",
      url: "/co-deals",
    },
    {
      name: "Opérations commerciales",
      url: "/co-deals#operations_commerciales",
    },
  ];
  return (
    <header className={cx(isEtendu && "etendu")}>
      <div className="topResponsive">
        <Link to="/co-deals" className="link-logo">
          <img src={logo} alt="Logo Co-Deals" className="logo" />
        </Link>
        <ButtonHamburger
          onClick={() => {
            setIsEtendu(!isEtendu);
          }}
        />
      </div>
      <Nav links={links} />
      <div id="mon_compte">
        <Link to="/co-deals/mon_compte">Mon Compte</Link>
      </div>
    </header>
  );
}

export default Header;
